import { factory, getResponseCamelization } from '@repo-level/core-front';
import { buildCmsUrl, CMSApiBase, CMSImageBase, getResponseCMS } from './base';
import { isCMSV3 } from 'helpers/conf';

export interface BrandAssets {
  logoDesktop: CMSImageBase | null;
  logoMobile: CMSImageBase | null;
  preloader: CMSImageBase | null;
  animatedLogo: boolean;
}

interface CMSBrandAssets extends BrandAssets, CMSApiBase {}

export const brandAssetsV3 = factory((r) => () =>
  r<CMSBrandAssets>('get', buildCmsUrl({ path: 'brand-assets' }))
);

export const brandAssetsV4 = factory((r) => () =>
  r<CMSBrandAssets>(
    'get',
    buildCmsUrl({
      path: 'brand-asset',
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);

export const brandAssets = isCMSV3 ? brandAssetsV3 : brandAssetsV4;
